import {Action, Reducer} from 'redux'
import {CLEAR_STATE} from './actionTypes'

/**
 * reducer enhancer useful for clearing state
 * @param reducer
 */
const reducerEnhance = <S>(reducer: Reducer<S>) => (
  (state: S, action: Action) => {
    if (action.type === CLEAR_STATE) {
      return reducer(undefined as any, action)
    }

    return reducer(state, action)
  }
)

export default reducerEnhance



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/store/enhancers/clearStateEnhance/enhance.ts